// extracted by mini-css-extract-plugin
export default {"more_tabs":"index_more_tabs_7EBUE","title":"index_title_Mc9cg","more":"index_more_M25vg"};